export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-[#1a2744] focus:px-4 focus:py-2 focus:text-white focus:shadow-lg focus:outline focus:outline-2 focus:outline-[#c8a415]"
    >
      Pular para o conteúdo
    </a>
  );
}
